/**
 * Name: New Playlist Reducer
 * Author: @Gaurav
 * Date: 19-07-2021
 */
export default function reducer(
  state = {
    status: 'uninitiated',
    result: {},
  },
  action
) {
  switch (action.type) {
    case 'NEW_PLAYLIST_INITIATED': {
      return { ...state, status: 'initiated' };
    }
    case 'NEW_PLAYLIST_SUCCESS': {
      return { ...state, status: 'success', result: action.payload };
    }
    case 'NEW_PLAYLIST_FAILED': {
      return { ...state, status: 'failed', result: action.payload };
    }
    default: {
      return state;
    }
  }
}
